import {FC} from 'react'
import {Form} from 'react-bootstrap'
import {CoefIoLm} from '../../coef-io-lm/core/_models'
import {OecdDescription} from '../../oecd-descriptions/core/_models'

type Props = {
  coefIoLmDetail: CoefIoLm
  oecdList: OecdDescription[]
}

const CoefIoLmDetailView: FC<Props> = ({coefIoLmDetail, oecdList}) => {
  const renderValue = (value?: string | number | null) => {
    if (value === null || value === undefined || value === '') return '-'
    return String(value)
  }

  const resolveOecdLabel = (code: string | null): string => {
    if (!code) return '-'
    const match = oecdList.find((o) => o.code === code)
    if (!match) return code
    const truncDesc = match.desc ? match.desc.substring(0, 80) : ''
    return truncDesc ? `${code} — ${truncDesc}` : code
  }

  return (
    <div className='detail-coef-io-lm'>
      <div className='row mb-4'>
        <div className='col-md-6 mb-3'>
          <Form.Label>ISO</Form.Label>
          <div className='data-value fw-semibold'>{renderValue(coefIoLmDetail.iso)}</div>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label>Year</Form.Label>
          <div className='data-value fw-semibold'>{renderValue(coefIoLmDetail.year)}</div>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label>Input</Form.Label>
          <div className='data-value'>{resolveOecdLabel(coefIoLmDetail.input)}</div>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label>Output</Form.Label>
          <div className='data-value'>{resolveOecdLabel(coefIoLmDetail.output)}</div>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label>Coef</Form.Label>
          <div className='data-value'>
            {coefIoLmDetail.coef !== null && coefIoLmDetail.coef !== undefined
              ? coefIoLmDetail.coef
              : '-'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoefIoLmDetailView
